import React from "react";
import moment from "moment";
import { useTranslation } from "react-i18next";
import {
  GrLocation,
  GrMailOption,
  GrPersonalComputer,
  GrPhone,
} from "react-icons/gr";
import "./style.css";

export const Home = () => {
  const [t] = useTranslation("global");

  const date = moment();

  return (
    <div className="home-section font-Poppins bg-gray-50">

      <div className="container-left coverImage">
        <p className="text-4xl font-bold text-gray-800 font-Poppins">{t("hi")}</p>
        <p className="text-3xl font-font-semibold text-gray-800 font-Poppins">
         {t("hi-my-name")}
        </p>
        <br />
        <p className="text-1xl font-font-semibold text-gray-800 font-Poppins font-medium text-justify">
          {t("que-tal")}{" "}
          {date.format("YYYY") - 2000} {t("anos-de-edad")} {date.format("YYYY") - 2020} {t("anoos-de-expe")}.
          <br />
          <br />
          {t("my-lv")}{" "}
          {date.format("YYYY") - 2015} {" "}
          {t("annoss")}
          <br />
          <br />
         {t("avanzado")}
        </p>
        <br />
        <div className=" flex flex-col">
          <div className="flex m-3">
            <GrPersonalComputer className="font-black bg-yellow-400 p-1 rounded-md text-3xl" />
            <p className="mx-3 text-gray-800 font-medium font-Poppins">
              <span className="font-semibold ">{t("profesion")}</span>
              <br />
              Web Developer
            </p>
          </div>
          <div className="flex m-3">
            <GrPhone className="font-black bg-yellow-400 p-1 rounded-md text-3xl cursor-pointer" />
            <p className="mx-3 text-gray-800 font-medium font-Poppins">
              <span className="font-semibold">{t("phone")}</span>
              <br />
              +505-8223-0224
            </p>
          </div>
          <div className="flex m-3">
            <GrMailOption className="font-black bg-yellow-400 p-1 rounded-md text-3xl" />
            <p className="mx-3 text-gray-800 font-medium font-Poppins">
              <span className="font-semibold">{t("personal-email")}</span>
              <br />
              gkevinyamil@gmail.com
            </p>
          </div>
          <div className="flex m-3">
            <GrLocation className="font-black bg-yellow-400 p-1 rounded-md text-3xl" />
            <p className="mx-3 text-gray-800 font-medium font-Poppins">
              <span className="font-semibold">{t("location")}</span>
              <br />
              San Marcos, Carazo - Nicaragua
            </p>
          </div>
        </div>
      </div>
      <div>
        <div className="bg-gray-50">
          <div className="coverImage">
            <img loading='lazy'
              src={"https://res.cloudinary.com/devsing/image/upload/cs_keep_cmyk,dl_95,f_webp/v1654288832/Portfolio/IMG_20211218_181222_anplvi.jpg"}
              alt="Kevin Garcia"
              className="rounded-full shadow-md transform -rotate-45 p-2 tabletbig:p-6 bg-yellow-400 ring-2 ring-gray-200"
            />
          </div>
        </div>
        <div className="Big-Circle"></div>
      </div>
    </div>
  );
};
